<template>
    <div class="communications-tab row nav-padding">
        <div class="d-flex align-items-center justify-content-between">
            <div class="px-3">
                <div v-if="communications.length">
                    <span class="_700">Results:</span> {{ communications.length }}
                </div>
            </div>

            <div class="d-flex justify-content-end px-3 pt-3">
                <div class="mr-2">
                    <company-autosuggest v-model="company_id"></company-autosuggest>
                </div>

                <div class="mr-2">
                    <el-input
                            placeholder="Type something to search"
                            prefix-icon="el-icon-search"
                            v-model="search_text"
                            @clear="communications = []"
                            @keyup.enter.native="handleSearch"
                            clearable>
                    </el-input>
                </div>

                <div class="mr-2">
                    <el-select v-model="search_field" placeholder="Select a search field">
                        <el-option
                            v-for="item in search_field_options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>

                <div>
                    <el-button
                        v-if="showClearFiltersButton"
                        @click="clearFilters()">
                        Reset Filters
                    </el-button>

                    <el-button
                        type="success"
                        @click="handleSearch"
                        :disabled="searching">
                        Search
                    </el-button>
                </div>
            </div>
        </div>


        <div class="w-100 pt-5">
            <div
                v-if="communications.length"
                class="p-3">
                <el-table
                    :data="communications"
                    style="width: 100%">
                    <el-table-column label="ID">
                        <template v-slot="scope">
                            <span v-bind:class="highlight(scope.row.id)">{{ scope.row.id }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Company">
                        <template v-slot="scope">
                            <p class="mb-0">{{ scope.row.company.name }}</p>
                            <p class="mb-0">#{{ scope.row.company.id }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="Lead Number">
                        <template v-slot="scope">
                            <span v-bind:class="highlight(scope.row.lead_number)">
                                {{ scope.row.lead_number ? scope.row.lead_number : '-' }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Incoming Number">
                        <template v-slot="scope">
                            <span v-bind:class="highlight(scope.row.incoming_number)">
                                {{ scope.row.incoming_number ? scope.row.incoming_number : '-' }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="SID">
                        <template v-slot="scope">
                            <span>
                                {{ scope.row.sid ? scope.row.sid : '-' }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Agent Leg SID">
                        <template v-slot="scope">
                            <span>
                                {{ scope.row.agent_leg_sid ? scope.row.agent_leg_sid : '-' }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Customer Leg SID">
                        <template v-slot="scope">
                            <span>
                                {{ scope.row.customer_leg_sid ? scope.row.customer_leg_sid : '-' }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div v-else
                class="h-100 d-flex align-items-center">
                <div v-if="searching"
                    class="w-100">
                    <h3 class="text-center">Loading...</h3>
                </div>

                <div v-else-if="no_results"
                    class="w-100">
                    <h3 class="text-center">No results.</h3>
                </div>

                <div v-else
                    class="w-100 search-resource-text">
                    <div class="text-center">
                        <i class="fa fa-search"></i>
                        <p class="mb-0">Search communications</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CompanySelector from '../company-selector'
import CompanyAutosuggest from '../company-autosuggest'

export default {
    data() {
        return {
            communications: [],
            last_search_text: '',
            search_text: '',
            searching: false,
            search_field: 'id',
            search_field_options: [
                {
                    value: 'id',
                    label: 'ID'
                },
                {
                    value: 'lead_number',
                    label: 'Lead Number'
                },
                {
                    value: 'incoming_number',
                    label: 'Incoming Number'
                },
                // {
                //     value: 'phone_number',
                //     label: 'Phone Number'
                // }
            ],
            company_id: null,
            no_results: false
        }
    },

    components: {
        CompanySelector,
        CompanyAutosuggest
    },

    computed: {
        showClearFiltersButton() {
            return this.company_id || this.search_text || this.search_field != 'id'
        }
    },

    methods: {
        clearFilters() {
            this.company_id = null
            this.search_text = ''
            this.search_field = 'id'
            this.no_results = false
        },

        handleSearch() {
            if (!this.search_text) {
                return this.$notify.error({
                    title: 'Error',
                    message: 'Please enter a communication id, lead, incoming, or phone number before searching'
                })
            }

            if (!this.search_field) {
                return this.$notify.error({
                    title: 'Error',
                    message: 'Please select a search field'
                })
            }

            if ((
                this.search_field == 'lead_number' ||
                this.search_field == 'incoming_number' ||
                this.search_field == 'phone_number'
            ) && !(this.search_text.length >= 10)) {
                return this.$notify.error({
                    title: 'Error',
                    message: 'Please enter a 10 digit phone number'
                })
            }

            this.searching = true
            this.last_search_text = this.search_text

            let url = `/api/admin/communications/search?search_text=${this.search_text}&search_field=${this.search_field}`

            if (this.company_id) {
                url += `&company_id=${this.company_id}`;
            }

            axios.get(url)
                .then(response => {
                    const { data: communications } = response
                    if (communications.length == 0) {
                        this.no_results = true
                    } else {
                        this.no_results = false
                    }
                    this.communications = communications
                })
                .catch(error => {
                    this.$notify.error({
                        title: 'Error',
                        message: error.message
                    })
                })
                .finally(() => this.searching = false)
        },

        handleCompanyChange(company_id) {
            this.company_id = company_id
        },

        highlight(value) {
            if (!value) {
                return []
            }

            let classes = [],
                search_text = this.last_search_text.replace(/[- )(]/g,'');

            if (value.toString() == search_text || value.toString().includes(search_text)) {
                classes.push('highlight')
            }

            return classes;
        }
    }
}
</script>
